import React from "react"
import styled from "@emotion/styled"

const BannerWrapper = styled.div`
    & img {
        max-width: 100%;
        height: auto;
    }
`

const BannerBackground = styled.div`
    position: relative;
    width: 100%;
    padding-top: 36.5%;
    background: no-repeat;
    background-size: cover;
`

const CaptionBox = styled.div`
    position: absolute;
    right: 15%;
    left: 7%;
    z-index: 10;
    top: 7rem;
    width: 100%;

    & h1 {
        color: ${(props) => props.theme.colors.primary};
        margin-bottom: 0.5rem;
        font-style: italic;
    }
    & .description {
        color: ${(props) => props.theme.colors.text1};
    }

    @media screen and (min-width: 1441px) {
        left: 15%;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        left: 10%;
        top: 6rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[7]}) {
        top: 5rem;
        & h1 {
            font-size: 50px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        left: 10%;
        top: 4rem;
        & h1 {
            font-size: 40px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        top: 3rem;
        & h1 {
            font-size: 35px;
        }
        & .description {
            font-size: 14px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        top: 2.5rem;
        & h1 {
            font-size: 30px;
        }

        & .description {
            line-height: 1.2;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        left: 6%;
        top: 1rem;
        & h1 {
            font-size: 20px;
            margin-bottom: 0;
        }
        & .description {
            font-size: 12px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[1]}) {
        width: 95%;
        top: 0.3rem;
        & h1 {
            font-size: 18px;
        }
        & .description {
            font-size: 11px;
        }
    }
`

function topBanner({ data }) {
    const defaultBg = "/banner-homepage.jpg"
    const bg = data.image && data.image.publicURL
    
    return (
        <BannerWrapper>
            <BannerBackground
                style={{ backgroundImage: `url(${bg || defaultBg})` }}
            />
            <CaptionBox className="caption-box-topbanner">
                <div
                    className="description"
                    dangerouslySetInnerHTML={{ __html: data.description }}
                />
            </CaptionBox>
        </BannerWrapper>
    )
}

export default topBanner
